import { render, staticRenderFns } from "./videoMaterial.vue?vue&type=template&id=0c532936&"
import script from "./videoMaterial.vue?vue&type=script&lang=ts&"
export * from "./videoMaterial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports